import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import * as Yup from "yup";
import Labels from "../../labels/Labels";

const addUserValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter a valid email address")
    .max(255, "Email must not exceed 255 characters")
    .required("Email is required"),
  firstName: Yup.string()
    .max(100, "First name must not exceed 100 characters")
    .matches(
      /^[a-zA-Z]*$/,
      "First name can only contain letters"
    ),
  lastName: Yup.string()
    .max(100, "Last name must not exceed 100 characters")
    .matches(
      /^[a-zA-Z]*$/,
      "Last name can only contain letters"
    ),
});

export default function AddUserDialog({
  open,
  onClose,
  subDepartmentId,
  onSubmit,
  isLoading,
  formikRef,
}) {
  const formik = useFormik({
    initialValues: {
      email: "",
      firstName: "",
      lastName: "",
    },
    validationSchema: addUserValidationSchema,
    onSubmit: (values) => {
      onSubmit(values);
    },
    enableReinitialize: true,
  });

  // Store formik instance in ref if provided
  if (formikRef) {
    formikRef.current = formik;
  }

  return (
    <Dialog open={open} fullWidth maxWidth="sm" onClose={onClose}>
      <DialogActions
        style={{ backgroundColor: "#DDE6ED", margin: 0, padding: 0 }}
      >
        <div style={{ width: "100%" }}>
          <DialogTitle>
            <Typography>
              {Labels.getLabel(
                "manageOrganizationalUnit.addUserTitle",
                "Add User to Organizational Unit"
              )}
            </Typography>
          </DialogTitle>
        </div>
        <IconButton onClick={onClose}>
          <CloseIcon variant="Outlined" />
        </IconButton>
      </DialogActions>

      <DialogContent>
        <Box
          component="form"
          onSubmit={formik.handleSubmit}
          sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}
        >
          <TextField
            fullWidth
            name="email"
            label={Labels.getLabel("manageOrganizationalUnit.email", "Email")}
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={isLoading}
            required
            type="email"
            inputProps={{ maxLength: 255 }}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />

          {/* <TextField
            fullWidth
            name="firstName"
            label={Labels.getLabel(
              "manageOrganizationalUnit.firstName",
              "First Name"
            )}
            value={formik.values.firstName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={isLoading}
            inputProps={{ maxLength: 100 }}
            error={formik.touched.firstName && Boolean(formik.errors.firstName)}
            helperText={formik.touched.firstName && formik.errors.firstName}
          />

          <TextField
            fullWidth
            name="lastName"
            label={Labels.getLabel(
              "manageOrganizationalUnit.lastName",
              "Last Name"
            )}
            value={formik.values.lastName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={isLoading}
            inputProps={{ maxLength: 100 }}
            error={formik.touched.lastName && Boolean(formik.errors.lastName)}
            helperText={formik.touched.lastName && formik.errors.lastName}
          /> */}
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          {Labels.getLabel("manageOrganizationalUnit.cancel", "Cancel")}
        </Button>
        <Button
          onClick={formik.handleSubmit}
          variant="contained"
          color="primary"
          disabled={isLoading}
          startIcon={isLoading ? <CircularProgress size={20} /> : null}
        >
          {Labels.getLabel("manageOrganizationalUnit.addUser", "Add User")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
